<template>
	<div v-if="data">
		<div class="">
			<div class="row">
				<div class="col-md-12 p-r-0 p-l-0 embed-responsive-column">
					<div class="embed-responsive embed-responsive-16by9">
						<iframe :src="link" class="embed-responsive-item" frameborder="0"></iframe>
					</div>
				</div>
				<!--
				<div class="col-md-2 col-md-pull-10 p-r-0 p-l-0">
					<template v-if="data.assigned">
						<template v-if="data.assigned.profile">
							<div class="text-center p-t-20">
								<template v-if="data.assigned.profile.avatar">
									<img :src="data.assigned.profile.avatar" width="200" class="img-circle img-responsive p-r-30 p-l-30 center-block">
								</template>
								<h3>
									<strong>{{ data.assigned.profile.first_name }} {{ data.assigned.profile.last_name }}</strong>
								</h3>
								<p>
									<span v-if="data.assigned.profile.mobile">
										<a :href="'tel:' + data.assigned.profile.mobile">
											{{ data.assigned.profile.mobile }}
										</a>
									</span><br>
									<span v-if="data.assigned.email">
										<a :href="'mailto:' + data.assigned.email">
											{{ data.assigned.email }}
										</a>
									</span>
								</p>
								<p v-if="$platform.place">
									{{ $platform.place.name }}<br>
									{{ $platform.place.postal_code }} {{ $platform.place.locality }}<br>
									{{ $platform.place.administrative_area_level_2 }} {{ $platform.place.country }}<br>
								</p>
							</div>
						</template>
					</template>
					<hr>
					<h2 class="text-center">
						<strong>Presupuesto Nº{{ data.id }}</strong>
					</h2>
					<template v-if="data.budget_status_id == 5">
						<div class="text-center">
							<template v-if="data.status">
								<button :class="'btn btn-' + data.status.class + ' btn-lg btn-rounded m-b-20 no-link'">
									<template v-if="data.status.lang">
										{{ data.status.lang.name }}
									</template>
									<template>
										{{ data.status.name }}
									</template>
								</button>
							</template>
						</div>
					</template>
					<template v-else>
						<template v-if="!user">
							<div class="text-center">
								<button v-if="data.budget_status_id == 2" @click="open" class="btn btn-success btn-lg btn-rounded m-b-20">
									Aceptar
								</button>
							</div>
						</template>
					</template>
					<div class="btn-group-vertical btn-block m-t-20" role="group">
						<template v-if="data.assigned">
							<template v-if="data.assigned.profile">
								<template v-if="data.assigned.profile.mobile">
									<a :href="'tel:' + data.assigned.profile.mobile" class="btn btn-default">
										<i class="fa fa-phone" aria-hidden="true"></i> Llamar
									</a>
								</template>
							</template>
							<a :href="'mailto:' + data.assigned.email" class="btn btn-default">
								<i class="fa fa-envelope-o" aria-hidden="true"></i> Enviar correo
							</a>
							<template v-if="apiWhatsapp">
								<a :href="apiWhatsapp" target="_blank" class="btn btn-default">
									<i class="fa fa-whatsapp" aria-hidden="true"></i>
									Enviar mensaje
								</a>
							</template>
						</template>
					</div>
				</div>
				-->
			</div>
		</div>
	</div>
</template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'
	export default {
		props: ['user', 'isAuth'],
		data () {
			return {
				random: this.$route.params.random,
				data: null,
				link: null,
			}
		},
		created() {
			this.init()
		},
		methods: {
			init() {
				this.getData()
			},
			open() {
				var modal = $('#'+this.modal.selector)
				modal.modal('show')
			},
			close() {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			getData() {
				if(this.random) {
					this.$http.get('agreements/' + this.random)
					.then(response => {
						this.data = response.body
						this.loadLink()
					}, function(error) {
						console.log(error)
					})
				}
			},
			loadLink() {
				this.link = this.$env.ROOT + '/' + this.$lang.getLang() + '/' + this.$platform.slug +'/pdf/viewer'
				if(this.data) {
					if(this.data.link) {
						this.link = this.link + '?file=' + this.data.link
					}
				}
			},
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/public/agreements/views/AgreementViewer.vue